import React from "react";
import styles from "./ColorRadioOption.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import Color from "color";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faCheck } from "@fortawesome/free-solid-svg-icons";

/**
 * Interactive component. A radio button that allows the user to select the current color.
 */
export function ColorRadioOption({ isSelected, setCurrentColor, color, name }) {
  const colorObject = Color(color);
  const white = Color("white").hex();

  return (
    <div
      onClick={setCurrentColor}
      title={name ?? "custom"}
      className={styles.container}
      style={{ backgroundColor: color }}
    >
      <input
        type="radio"
        name={name ?? "custom"}
        value={`${name} ${color}`}
        hidden
        title={name ?? "custom"}
        defaultChecked={isSelected}
      />
      {colorObject.hex() === white && name === "default" ? (
        <span className={styles.ban}>
          <FontAwesomeIcon icon={faBan} />
        </span>
      ) : null}
      <span
        // Checks background contrast
        style={{ color: colorObject.isLight() ? "black" : "white" }}
        className={classNames(styles.check, {
          [styles.hidden]: !isSelected,
          [styles["visible-border"]]:
            colorObject.hex() === white && name !== "default",
        })}
      >
        <FontAwesomeIcon icon={faCheck} />
      </span>
    </div>
  );
}

ColorRadioOption.propTypes = {
  /**
   * Boolean that determines if the radio button is checked.
   */
  isSelected: PropTypes.bool,
  /**
   * Function that sets the currentColor to the color value.
   * Retrieve value using event.target.style.backgroundColor.
   */
  setCurrentColor: PropTypes.func,
  /**
   * The color value of radio button.
   * If 'default', color is white with a prohibit icon.
   * Must be validated as a color before being passed as a prop.
   */
  color: PropTypes.string,
  /**
   * Optional name for the color.
   */
  name: PropTypes.string,
};
